export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    // options
    multiVideo: false,
    showOnMobile: true,
    maxVideos: 1,
    autoPlayVideo: false,
    loopVideo: true, // Autoplay must be enabled
    showControls: true,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length >= 1) {
        $('#videoSection').append(`<div class="video-tag">Watch</div`);
        $('.tier-four').addClass('is-loaded');
      } else {
        $('#videoSection').remove();
      }
    },
  });
}
